import React from "react"

import ConceptMappingItem from "./ConceptMappingItem"
import KnowledgeListItem from "../knowledge-list/KnowledgeListItem"
import SpinnerImage from "../SpinnerImage"

const ConceptMappingPreview = ({
    previewMapping,
    isDeleting,
    afterCount,
    beforeCount,
    after,
    isFetching
}) => (
    <div className="mapping-preview">
        <h3>
            <span className="icon icon-article" />
            Article preview
        </h3>
        <div className="preview-tags">
            <div className="mapping-box">
                <ConceptMappingItem
                    key={previewMapping.id || previewMapping.fakeId}
                    {...previewMapping}
                />
            </div>
        </div>
        <div className="preview-info">
            <h4>
                After {isDeleting ? "deleting" : "adding"}: &nbsp;
                {isFetching ? (
                    <SpinnerImage />
                ) : (
                    <span
                        className={
                            afterCount < beforeCount ? "negative-count" : ""
                        }
                    >
                        {afterCount} (
                        {afterCount > beforeCount && "+"}
                        {afterCount - beforeCount}
                        )
                    </span>
                )}
            </h4>
            <h4>
                (Before {isDeleting ? "deleting" : "adding"}: &nbsp;
                {isFetching ? <SpinnerImage /> : beforeCount})
            </h4>
        </div>
        <div className="list-group items-list auto">
            {isFetching && <SpinnerImage isCentral={true} />}
            {(after || []).map(knowledge => (
                <KnowledgeListItem key={knowledge.id} {...knowledge} />
            ))}
            {(!after || after.length <= 0) && <p>No articles</p>}
        </div>
    </div>
)

export default ConceptMappingPreview
